export default __webpack_public_path__ + "static/oreo-logo-7653d540724886d0a6b7b44d81fa8b12.png";